function EtapesProjet() {
  const etapes = ['Prise de contact avec i2c', 'Rendez-vous client', 'Mise en place du projet', 'Selection des intervenants', 'Réalisation du projet', 'Retours et garantie'];

  return (
    <div id="etape_du_projet" className="flex flex-col gap-[50px] mt-6">
      <h3 className="px-6 text-center text-[40px] font-extrabold text-gris-sombre dark:text-blanc-sombre">
        Les étapes de votre <span className="text-bleu-je">projet</span>
      </h3>

      <div className="flex flex-col gap-4 px-4 w-full max-w-[1100px] mx-auto">
        {/* Container de la jauge */}
        <div className="relative w-full h-[50px] flex items-center">
          {/* Barre de fond grise */}
          <div className="absolute top-1/2 left-0 w-full h-2 bg-gray-300 rounded-full transform -translate-y-1/2"></div>

          {/* Barre de progression animée */}
          <div className="absolute top-1/2 left-0 h-2 bg-bleu-je rounded-full transform -translate-y-1/2 animate-fillWidth" style={{ width: '60%' }}></div>

          {/* Cercles positionnés équitablement */}
          <div className="flex justify-between w-full z-10">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="w-[23px] h-[23px] bg-bleu-je rounded-full"></div>
            ))}
          </div>
        </div>

        {/* Textes sous les cercles */}
        <div className="flex justify-between w-full">
          {etapes.map((etape, index) => (
            <div key={index} className="flex flex-col items-center w-[60px] sm:w-[50px] md:w-[110px]">
              <h3 className="text-bleu-footer dark:text-bleu-je font-semibold text-[10px] sm:text-xs md:text-sm text-center">Étape {index + 1}</h3>
              <p className="text-gris-sombre dark:text-blanc-sombre text-[9px] sm:text-[10px] md:text-[11px] lg:text-sm text-center break-words leading-tight">
                {etape}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default EtapesProjet;